"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exploration = void 0;
const zod_1 = require("zod");
const generic_1 = require("./generic");
const _1 = require(".");
var exploration;
(function (exploration_1) {
    const deprecatedVisualisation = zod_1.z.object({
        groups: zod_1.z.array(_1.common.grouping),
        aggregations: zod_1.z.array(_1.common.aggregation),
        viewOptions: zod_1.z.record(zod_1.z.unknown()).optional(),
    });
    exploration_1.aggregatedVisualisation = zod_1.z.object({
        aggregation: zod_1.z.object({
            groups: zod_1.z.array(_1.common.grouping),
            aggregations: zod_1.z.array(_1.common.aggregation),
        }),
        mainAxisKey: zod_1.z.string().optional(),
        valueKeys: zod_1.z.array(zod_1.z.string()),
        viewOptions: zod_1.z.record(zod_1.z.unknown()).optional(),
    });
    exploration_1.simpleVisualisation = zod_1.z.object({
        mainAxisKey: zod_1.z.string().optional(),
        valueKeys: zod_1.z.array(zod_1.z.string()),
        viewOptions: zod_1.z.record(zod_1.z.unknown()).optional(),
    });
    exploration_1.visualisation = exploration_1.aggregatedVisualisation.or(exploration_1.simpleVisualisation).or(deprecatedVisualisation);
    const cellViewOptions = zod_1.z.record(generic_1.json);
    const recordsViewCell = zod_1.z.object({
        id: zod_1.z.string(),
        kind: zod_1.z.literal('records'),
        title: zod_1.z.string().optional(),
        excludeProperties: zod_1.z.array(zod_1.z.string()).optional().nullable(),
        pipeline: _1.pipeline.pipelineWithInstances,
        visualisations: zod_1.z.array(exploration_1.visualisation).optional(),
        sort: _1.common.sorting.array().optional().nullable(),
        viewOptions: cellViewOptions.optional(),
    });
    exploration_1.sqlViewCell = zod_1.z.object({
        id: zod_1.z.string(),
        kind: zod_1.z.literal('sql'),
        title: zod_1.z.string().optional(),
        pipeline: _1.pipeline.basePipeline,
        viewOptions: cellViewOptions.optional(),
    });
    exploration_1.pythonViewCell = zod_1.z.object({
        id: zod_1.z.string(),
        kind: zod_1.z.literal('python'),
        title: zod_1.z.string().optional(),
        pipeline: _1.pipeline.basePipeline,
        viewOptions: cellViewOptions.optional(),
    });
    const metricViewCell = zod_1.z.object({
        id: zod_1.z.string(),
        kind: zod_1.z.literal('metric'),
        metricId: zod_1.z.string(),
        viewOptions: cellViewOptions.optional(),
    });
    const funnelViewCell = zod_1.z.object({
        id: zod_1.z.string(),
        kind: zod_1.z.literal('funnel'),
        title: zod_1.z.string().optional(),
        pipeline: _1.pipeline.basePipeline,
        viewOptions: cellViewOptions.optional(),
    });
    const cohortViewCellZod = zod_1.z.object({
        id: zod_1.z.string(),
        kind: zod_1.z.literal('cohort'),
        title: zod_1.z.string().optional(),
        pipeline: _1.pipeline.pipelineWithInstances,
        viewOptions: cellViewOptions.optional(),
    });
    const inputViewCell = zod_1.z.object({
        id: zod_1.z.string(),
        kind: zod_1.z.literal('variable'),
        definition: zod_1.z.any(),
        viewOptions: cellViewOptions.optional(),
    });
    const textViewCell = zod_1.z.object({
        id: zod_1.z.string(),
        kind: zod_1.z.literal('text'),
        title: zod_1.z.string().optional(),
        content: zod_1.z.string().optional(),
        viewOptions: cellViewOptions.optional(),
    });
    const invalidViewCell = zod_1.z.object({
        id: zod_1.z.string(),
        kind: zod_1.z.literal('invalid'),
        title: zod_1.z.string().optional(),
        message: zod_1.z.string(),
        viewOptions: cellViewOptions.optional(),
        cell: zod_1.z.record(generic_1.json),
    });
    const viewCell = zod_1.z.union([
        recordsViewCell,
        exploration_1.sqlViewCell,
        exploration_1.pythonViewCell,
        metricViewCell,
        funnelViewCell,
        cohortViewCellZod,
        inputViewCell,
        textViewCell,
        invalidViewCell,
    ]);
    const canvasOptions = zod_1.z.object({
        nodes: zod_1.z.array(zod_1.z.object({
            id: zod_1.z.string(),
            position: zod_1.z.object({
                x: zod_1.z.number(),
                y: zod_1.z.number(),
            }),
            measured: zod_1.z.object({
                width: zod_1.z.number(),
                height: zod_1.z.number(),
            }),
        })),
        edges: zod_1.z.array(zod_1.z.object({
            id: zod_1.z.string(),
            source: zod_1.z.string(),
            target: zod_1.z.string(),
        })),
    });
    exploration_1.exploration = zod_1.z.object({
        explorationId: zod_1.z.string(),
        name: zod_1.z.string(),
        description: zod_1.z.string().optional().nullable(),
        labels: zod_1.z.record(zod_1.z.string()).optional(),
        parameters: zod_1.z
            .array(zod_1.z.object({
            key: zod_1.z.string(),
            modelId: zod_1.z.string(),
        }))
            .default([]),
        view: zod_1.z.object({
            cells: zod_1.z.array(viewCell),
            canvas: canvasOptions.optional(),
        }),
    });
})(exploration || (exports.exploration = exploration = {}));
//# sourceMappingURL=exploration.js.map